import React, { useEffect, useState } from 'react';
import CMSService from '../../services/CMSService';
import { LandingPageGlobal, Course, BlogPost, StudentHonorsSection, WhyChooseUsSection, LearningSpaceSection, TestSetsSection as TestSetsSectionType, VideoSection } from '../../types';
import Header from '../../components/landingpage/Header';
import VideoHeader from '../../components/landingpage/sections/VideoHeader';
import LearningSpace from '../../components/landingpage/sections/LearningSpace';
import SocialToolbox from '../../components/landingpage/SocialToolbox';
import RecommendedCourses from '../../components/landingpage/sections/RecommendedCourses';
import MagazineSection from '../../components/landingpage/sections/MagazineSection';
import TestSetsSection from '../../components/landingpage/sections/IELTSMaterials';
import StudentShowcase from '../../components/landingpage/sections/StudentShowcase';
import WhyChooseUs from '../../components/landingpage/sections/WhyChooseUs';
import Footer from '../../components/landingpage/Footer';
import IELTSMaterials from '../../components/landingpage/sections/IELTSMaterials';

/**
 * DEFAULT FALLBACK DATA FOR ALL SECTIONS
 * Used when API fails or returns null
 */

// Fallback blog posts for Magazine section
const DEFAULT_BLOG_POSTS: BlogPost[] = [
  {
    _id: 'fallback-1',
    title: '10 Essential IELTS Vocabulary Words',
    slug: '10-essential-ielts-vocabulary',
    content: 'Master these crucial vocabulary words to boost your IELTS score...',
    excerpt: 'Learn the top 10 vocabulary words that frequently appear in IELTS exams.',
    blogType: 'Announcement',
    difficulty: 'Easy',
    author: 'Admin',
    featuredImage: '/blog/placeholder-1.jpg',
    status: 'Published',
    views: 1250,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: 'admin',
  },
  {
    _id: 'fallback-2',
    title: 'IELTS Speaking Part 2: Complete Guide',
    slug: 'ielts-speaking-part-2-guide',
    content: 'Everything you need to know about IELTS Speaking Part 2...',
    excerpt: 'Master the cue card section with our comprehensive guide and tips.',
    blogType: 'Tips',
    difficulty: 'Medium',
    author: 'Admin',
    featuredImage: '/blog/placeholder-2.jpg',
    status: 'Published',
    views: 2100,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: 'admin',
  },
  {
    _id: 'fallback-3',
    title: 'Writing Task 1: Describing Graphs',
    slug: 'writing-task-1-graphs',
    content: 'Complete guide to writing Task 1 with graph descriptions...',
    excerpt: 'Learn how to describe different types of graphs and charts effectively.',
    blogType: 'Tips',
    difficulty: 'Medium',
    author: 'Admin',
    featuredImage: '/blog/placeholder-3.jpg',
    status: 'Published',
    views: 1890,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: 'admin',
  },
  {
    _id: 'fallback-4',
    title: 'IELTS Listening: Tips and Tricks',
    slug: 'ielts-listening-tips',
    content: 'Proven strategies to improve your IELTS Listening score...',
    excerpt: 'Discover effective techniques for the IELTS Listening section.',
    blogType: 'Tips',
    difficulty: 'Easy',
    author: 'Admin',
    featuredImage: '/blog/placeholder-4.jpg',
    status: 'Published',
    views: 3050,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: 'admin',
  },
  {
    _id: 'fallback-5',
    title: 'Reading Comprehension Strategies',
    slug: 'reading-comprehension-strategies',
    content: 'Master reading comprehension with advanced strategies...',
    excerpt: 'Boost your reading score with these proven techniques.',
    blogType: 'Announcement',
    difficulty: 'Hard',
    author: 'Admin',
    featuredImage: '/blog/placeholder-5.jpg',
    status: 'Published',
    views: 1620,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: 'admin',
  },
  {
    _id: 'fallback-6',
    title: 'Band 9 Writing Sample Essays',
    slug: 'band-9-writing-samples',
    content: 'Analyze real Band 9 Writing essays to understand excellence...',
    excerpt: 'Study high-scoring essays and learn what makes them effective.',
    blogType: 'Announcement',
    difficulty: 'Hard',
    author: 'Admin',
    featuredImage: '/blog/placeholder-6.jpg',
    status: 'Published',
    views: 2540,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: 'admin',
  },
];

// Fallback courses for Recommended Courses section


// Fallback student honors data
const DEFAULT_STUDENT_HONORS: StudentHonorsSection = {
  title: 'Câu Chuyện Thành Công Của Học Viên',
  displayCount: 6,
  students: [
    {
      _id: 'student-1',
      name: 'Nguyễn Thị Hạnh',
      level: 'Band 8.0',
      profileImage: '/images/student-1.jpg',
      honorDescription: 'Đạt Band 8.0 sau 3 tháng học tập với kỳ lực',
      isBronze: false,
    },
    {
      _id: 'student-2',
      name: 'Trần Minh Huy',
      level: 'Band 7.5',
      profileImage: '/images/student-2.jpg',
      honorDescription: 'Cải thiện từ Band 6.0 lên Ban 7.5 trong 2 tháng',
      isBronze: true,
    },
    {
      _id: 'student-3',
      name: 'Phạm Lan Anh',
      level: 'Band 8.0',
      profileImage: '/images/student-3.jpg',
      honorDescription: 'Đạt mục tiêu Band 8.0 để du học Anh Quốc',
      isBronze: false,
    },
    {
      _id: 'student-4',
      name: 'Lý Hoàng Long',
      level: 'Band 7.5',
      profileImage: '/images/student-4.jpg',
      honorDescription: 'Chinh phục IELTS Speaking qua luyện tập thường xuyên',
      isBronze: true,
    },
    {
      _id: 'student-5',
      name: 'Vũ Thị Hương',
      level: 'Band 8.0',
      profileImage: '/images/student-5.jpg',
      honorDescription: 'Thành công trong kỳ thi IELTS lần đầu tiên',
      isBronze: false,
    },
    {
      _id: 'student-6',
      name: 'Đặng Quốc Tuấn',
      level: 'Band 7.0',
      profileImage: '/images/student-6.jpg',
      honorDescription: 'Đạt Band 7.0 nhờ phương pháp học hiệu quả',
      isBronze: true,
    },
  ],
};

// Fallback Why Choose Us data
const DEFAULT_WHY_CHOOSE_US: WhyChooseUsSection = {
  title: 'Tại Sao Chọn Chúng Tôi',
  features: [
    {
      icon: 'chalkboard-user',
      title: 'Giáo Viên Chuyên Gia',
      description: 'Giáo viên IELTS có kinh nghiệm và chứng chỉ quốc tế',
    },
    {
      icon: 'book',
      title: 'Tài Liệu Toàn Diện',
      description: 'Tài liệu học tập cập nhật và các bài kiểm tra thực hành',
    },
    {
      icon: 'chart-line',
      title: 'Theo Dõi Tiến Độ',
      description: 'Giám sát sự cải thiện của bạn bằng phân tích chi tiết',
    },
    {
      icon: 'certificate',
      title: 'Kết Quả Chứng Chỉ',
      description: 'Nhận chứng chỉ công nhận sau khi hoàn thành',
    },
  ],
};

// Fallback Learning Space data
const DEFAULT_LEARNING_SPACE: LearningSpaceSection = {
  title: 'Không Gian Học Tập Hiện Đại',
  description: 'Truy cập nền tảng học tập tiên tiến của chúng tôi được thiết kế cho sự thành công của bạn',
  images: [{ image: '/learning-space.jpg' }],
};

// Fallback Test Sets data
const DEFAULT_TEST_SETS: TestSetsSectionType = {
  title: 'Luyện Tập Với Đề Thi Thực',
  description: 'Truy cập các đề thi IELTS mô phỏng thực tế với giải thích chi tiết',
};

// Fallback Video Header data
const DEFAULT_VIDEO_SECTION: VideoSection = {
  title: 'Chinh Phục IELTS',
  subtitle: 'Chuẩn Bị IELTS',
  backgroundImage: '/hero-bg.jpg',
  videoUrl: '/hero-video.mp4',
  ctaText: 'Bắt Đầu Học Ngay',
  ctaLink: '/courses',
};

/**
 * DEFAULT_LANDING_PAGE_DATA
 * Complete fallback structure when API returns null
 */
const DEFAULT_LANDING_PAGE_DATA: LandingPageGlobal = {
  _id: 'fallback-landing-page',
  videoSection: DEFAULT_VIDEO_SECTION,
  testSets: DEFAULT_TEST_SETS,
  studentHonorsSection: DEFAULT_STUDENT_HONORS,
  whyChooseUs: DEFAULT_WHY_CHOOSE_US,
  learningSpaceSection: DEFAULT_LEARNING_SPACE,
  latestAnnouncementSection: {
    title: 'Bài Viết Mới Nhất',
    description: 'Đọc những bài viết mới nhất về IELTS và mẹo học tập',
    posts: DEFAULT_BLOG_POSTS,
  },
  updatedAt: new Date(),
  updatedBy: 'system',
};

/**
 * Landing Page (Home)
 * Public route - no authentication required
 * Shows: Hero, Courses, Blog Posts, Student Honors, Features, Learning Space
 */
const LandingPage: React.FC = () => {
  const [landingData, setLandingData] = useState<LandingPageGlobal>(DEFAULT_LANDING_PAGE_DATA);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadLandingPageData = async () => {
      try {
        const response = await CMSService.getLandingPageConfig();

        if (response.statusCode === 200 && response.data) {
          setLandingData(response.data);
          setError(null);
        } else {
          // Use fallback data when API fails
          setLandingData(DEFAULT_LANDING_PAGE_DATA);
          setError(response.error || 'Using default data');
          console.warn('Landing page API failed, using fallback data');
        }
      } catch (err) {
        // Use fallback data on error
        setLandingData(DEFAULT_LANDING_PAGE_DATA);
        const errorMsg = err instanceof Error ? err.message : 'Unknown error occurred';
        setError(errorMsg);
        console.warn('Landing page load error, using fallback data:', errorMsg);
      }
    };

    loadLandingPageData();
  }, []);
  
  return (
    <div className="bg-gray-100 dark:bg-gray-900 dark:text-white">
      {/* Scroll Progress Indicator */}
      <div className="scroll-progress" style={{ height: '3px', backgroundColor: '#017e6e' }}></div>

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main>
        <SocialToolbox />
        

        {/* Hero/Video Section */}
        <VideoHeader data={landingData.videoSection} />

        {/* Recommended Courses */}
        <RecommendedCourses />

        {/* Latest Announcements */}
        <MagazineSection data={landingData.latestAnnouncementSection} fallbackPosts={DEFAULT_BLOG_POSTS} />

        {/* IELTS Materials */}
        <IELTSMaterials data={landingData.testSets} />

        {/* Student Honors/Showcase */}
        <StudentShowcase data={landingData.studentHonorsSection} />

        {/* Why Choose Us */}
        <WhyChooseUs data={landingData.whyChooseUs} />

        {/* Learning Space */}
        <LearningSpace data={landingData.learningSpaceSection} />

        {error && (
          <div className="text-center py-10 text-yellow-600">
            <p>Lưu ý: Sử dụng dữ liệu mặc định - {error}</p>
          </div>
        )}
      </main>

      {/* Back to Top Button */}
      <div
        id="backToTop"
        className="fixed bottom-30 right-6 z-50 opacity-0 invisible transition-all duration-300"
      >
        <button className="bg-primary text-white w-10 h-10 rounded-full shadow-lg flex items-center justify-center hover:bg-blue-800 transition-colors">
          <i className="fas fa-arrow-up"></i>
        </button>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
